import { Component, OnInit } from '@angular/core'
import {
  UntypedFormBuilder,
  UntypedFormGroup,
  Validators,
} from '@angular/forms'
import { ActivatedRoute, Router } from '@angular/router'
import { MessageService } from 'primeng/api'
import { AuthService, UserService } from '../../../../api/services'
import { validateAllFormFields } from '../../../../formUtils'
import { CareFinitySession } from '../../../services/CareFinitySession'
import { CareFinityValidators } from '../../../validators/CareFinityValidators'
import { environment } from '../../../../../environments/environment'

@Component({
  selector: 'app-force-change-password',
  templateUrl: './force-password-change.component.html',
  styleUrls: ['./force-password-change.component.css'],
})
export class ForceChangePasswordComponent implements OnInit {
  changePassword: UntypedFormGroup
  errorValidationSummary: string = ''
  ShowErrorSummary: boolean = false
  userName: string = ''
  logoutmsg: string = ''
  display: boolean = false
  displaypopup: boolean = false

    private key: string
    version: string = '';


  constructor(
    private fb: UntypedFormBuilder,
    private router: Router,
    private userService: UserService,
    private messageService: MessageService,
    private route: ActivatedRoute,
    private auth: AuthService,
  ) {}

  ngOnInit() {
      this.displaypopup = true
      this.version = environment.version;
    this.route.queryParams.subscribe((params) => {
      let data = params
      this.userName = data.u_Name
    })
    this.changePassword = this.fb.group({
      newPassword: ['', Validators.required],
      confirmPassword: ['', Validators.required],
    })

    this.changePassword.setValidators(
      CareFinityValidators.Match('newPassword', 'confirmPassword'),
    )
  }

  resetPassword(): void {
    validateAllFormFields(this.changePassword)
    if (this.changePassword.invalid) {
      return
    }
    this.userService
      .userResetForgotPassword({
        uName: this.userName,
        Password: this.changePassword.get('newPassword').value,
      })
      .subscribe({
        next: (response) => {
          this.errorValidationSummary = response.message
          if (response.status == 'Error') {
            this.ShowErrorSummary = true
            this.messageService.add({
              key: 'alertToast',
              severity: 'error',
              summary: 'ERROR',
              detail: response.message,
              life: 5000,
            })
          } else if (response.status == 'Ok') {
            this.router.navigate(['/select-practice'])
          } else {
            this.ShowErrorSummary = true
            this.messageService.add({
              key: 'alertToast',
              severity: 'error',
              summary: 'Error',
              detail: response.message,
              life: 5000,
            })
          }
        },
        error: (err) => {
          this.ShowErrorSummary = true
          this.errorValidationSummary =
            'Server side error. Please try again later or Contact Support'
          console.error('Error resetting password', err)
          this.messageService.add({
            key: 'alertToast',
            severity: 'error',
            summary: 'Error',
            detail: 'An unexpected error occurred. Please try again later.',
            life: 5000,
          })
        },
      })
  }

  logout() {
    CareFinitySession.logout(this.auth)
    this.router.navigate(['login'])
  }
}
